// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextBombRenderer_wrapper__3EwJw","inline":"TextBombRenderer_inline__2rbre"};